import React, { useState } from 'react';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { Grid, Typography, Card, CardContent, IconButton } from '@mui/material';

import { infoIconStyle, infoIconButton, cardTitle } from '../../Dashboards/Market/styles/style';
import { TooltipCard } from '.';
import InfoTooltip from '../Tooltips/InfoTooltip';
import { DynamicPieChart } from 'src/App/Components/Charts';
import { PieDataCardPropTypes } from 'src/interfaces/iproptypes';

const PieDataCard = ({
  title,
  tooltipContent,
  data,
  unit,
  label,
  pieColors,
  pieAccentColor,
  radius,
}: PieDataCardPropTypes) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  return (
    // <Card>
      // <CardContent> 
        <Grid
          container
          direction="column"
          justifyContent="space-between"
          alignItems="flex-start"
          item
        >
          {title && (
            <Typography variant="h2" sx={cardTitle}>
              {title}
              {tooltipContent && (
                <InfoTooltip
                  title={
                    <TooltipCard
                      title={title}
                      content={tooltipContent}
                      link="https://support.airbtics.com/"
                    />
                  }
                  enterTouchDelay={0}
                  leaveTouchDelay={6000}
                  open={tooltipOpen}
                  onOpen={() => setTooltipOpen(true)}
                  onClose={() => setTooltipOpen(false)}
                >
                  <IconButton style={infoIconButton} onClick={() => setTooltipOpen(prev => !prev)}>
                    <InfoOutlinedIcon style={infoIconStyle} />
                  </IconButton>
                </InfoTooltip>
              )}
            </Typography>
          )}

          <Grid container item justifyContent={'flex-start'} xs ={12}>
            <DynamicPieChart
              data={data}
              unit={unit}
              pieColors={pieColors}
              pieAccentColor={pieAccentColor}
              label={label}
              radius={radius}
            /> 
          </Grid>
        </Grid>
      // </CardContent>
    // </Card>
  );
};

export default React.memo(PieDataCard);
